






import { defineComponent } from "@vue/composition-api";
import { ContentPurchase } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import UnlockedListItem from "../UnlockedListItem";

export default defineComponent({
  name: "UnlockedList",
  components: { UnlockedListItem },
  props: {
    items: { type: Array as () => ContentPurchase[], required: true },
  },
});
